// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-10211053].text a {\n  font-weight: var(--magic-font-weight-bold, 700);\n  text-decoration: none;\n}", ""]);
// Exports
module.exports = exports;
